import { Model } from ".";

export default class SpecSheet extends Model {
	get singularNoun() {
		return "spec sheet";
	}

	resource() {
		return "sales/spec-sheets";
	}
}
